module.exports = __webpack_public_path__ + "01_face.77419724.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer1/01_face.png
// module id = cZ6t
// module chunks = 0